import React, { FC, useRef } from 'react';

import DataGrid, {
  Column,
  ColumnChooser,
  Export,
  FilterPanel,
  FilterRow,
  GroupPanel,
  HeaderFilter,
  Pager,
  Paging,
  StateStoring,
} from 'devextreme-react/data-grid';

import { AppCard } from 'components/appComponents';
import { useAuth } from 'context/auth';

import { MaterialBalanceByFactoryTotals } from 'bus/factory/types';

type Props = {
  totals: MaterialBalanceByFactoryTotals[];
  onExporting: (e: any) => void;
};

const DetailTable = React.forwardRef<any, Props>(({ totals, onExporting }, ref) => {
  const { getClaims }: any = useAuth();

  const canLookPrice = getClaims(['CanLookPrice']);

  return (
    <AppCard>
      <DataGrid
        dataSource={totals}
        showBorders={false}
        loadPanel={{
          enabled: true,
          text: 'Загрузка',
        }}
        ref={ref}
        remoteOperations={true}
        allowColumnResizing
        columnResizingMode="nextColumn"
        columnMinWidth={50}
        allowColumnReordering
        onExporting={onExporting}
      >
        <Export enabled={true} />
        <StateStoring enabled={true} type="localStorage" storageKey="MaterialBalanceDetailTable" />
        <FilterRow visible={true} />
        <FilterPanel visible={true} />
        <HeaderFilter visible />
        <GroupPanel visible={false} />
        <ColumnChooser enabled={true} />

        <Column dataField="factoryName" caption="Завод" groupIndex={0} />
        <Column dataField="material" caption="Материал" />
        <Column
          dataField="inBalance"
          caption="Остаток начальный"
          cellRender={(data) => <div>{`${data.data.inBalance} ${data.data.unitName}`}</div>}
        />

        <Column
          dataField="income"
          caption="Приход материалов"
          cellRender={(data) => <div>{`${data.data.income} ${data.data.unitName}`}</div>}
        />
        <Column
          dataField="consumption"
          caption="Расход инерта"
          cellRender={(data) => <div>{`${data.data.consumption} ${data.data.unitName}`}</div>}
        />
        <Column
          dataField="outBalance"
          caption="Остаток конечный"
          cellRender={(data) => <div>{`${data.data.outBalance} ${data.data.unitName}`}</div>}
        />
        <Column
          dataField="price"
          caption="Стоимость, руб"
          visible={canLookPrice}
          cellRender={(data) => <div>{`${data.data.price}`}</div>}
        />

        <Paging defaultPageSize={1000} />
        <Pager showPageSizeSelector={true} visible={false} allowedPageSizes={[15, 30, 50, 100]} />
      </DataGrid>
    </AppCard>
  );
});

export default DetailTable;
